// Studies
export const CHARTIQ_STUDY_SET_STUDY_HELPER = 'chartiqstudy/SET_STUDY_HELPER';
export const CHARTIQ_STUDY_OPEN_STUDY_MODAL = 'chartiqstudy/OPEN_STUDY_MODAL';
export const CHARTIQ_STUDY_CLOSE_STUDY_MODAL = 'chartiqstudy/CLOSE_STUDY_MODAL';
export const CHARTIQ_STUDY_TOGGLE_STUDY_OVERLAY = 'chartiqstudy/TOGGLE_STUDY_OVERLAY';
export const CHARTIQ_STUDY_ADD_STUDY = 'chartiqstudy/ADD_STUDY';
export const CHARTIQ_STUDY_ADD_STUDY_AND_SAVE = 'chartiqstudy/ADD_STUDY_AND_SAVE';
export const CHARTIQ_STUDY_UPDATE_STUDY = 'chartiqstudy/UPDATE_STUDY';
export const CHARTIQ_STUDY_UPDATE_STUDY_AND_SAVE = 'chartiqstudy/UPDATE_STUDY_AND_SAVE';
export const CHARTIQ_STUDY_REMOVE_STUDY = 'chartiqstudy/REMOVE_STUDY';
export const CHARTIQ_STUDY_REMOVE_STUDY_AND_SAVE = 'chartiqstudy/REMOVE_STUDY_AND_SAVE';
